/*  
    To add new testimonial copy { .... } with curly brackets and comma at the end 
    and paste it inside [ ... ] same as other testimonials, follow the pattern 
*/
export const testimonials = [
  {
    author: 'Robert H. Jr',
    as: 'Tenant',
    text: `Thanks for helping me out. I feel that you have a strong work force and that the people working at Oasis Living are all knowledgeable, professional and respectful agents.`,
    image: 'faceless_avatar',
  },
  {
    author: 'Bernard Tenkorang',
    as: 'Tenant',
    text: `Very positive experience inside of a modern and up to date apartment. The property contained everything needed for a good solid stay.
      Highly recommended`,
    image: 'faceless_avatar',
  },
  {
    author: 'Matthew T.',
    as: 'Tenant',
    text: `Pros:
        | The accomodation met the expectations and was good overall.
        | Customer Service was always available and quick to respond.
        | Early check in was made possible.
  
        Cons:
        | The building itself, although new was quite noisy (flat next to elevator shaft).
        `,
    image: 'faceless_avatar',
  },
  {
    author: 'Assem Barnawi',
    as: 'Tenant',
    text: `Everything was great , check in and out , communication with host is great and easy. Safe location new and modern and have access to most facilities`,
    image: 'faceless_avatar',
  },
  // {
  //   author: 'Salome M Di',
  //   as: 'Tenant',
  //   as: 'Tenant',
  //   text: `Great experience, the apartment was lovely, very cosy and well located. The instructions to get in the flat were very clear, the hosts were very responsive and accessible even out of hours.
  //   I would highly recommend and would stay again.`,
  // image: "faceless_avatar"
  // },
  // {
  //   author: 'Dinh',
  //   as: 'Tenant',
  //   text: `Our stay was very pleasant, it was clean and exactly how the pictures portrayed it. We enjoyed our stay a lot. It’s also a great location and across the road from supermarket which was handy! Great and fast communication from hosts, very nice people! Very good amenities.
  //   Only thing I would say is it would’ve been nice to have a vacuum there as we were there for a longer period of time and dust collects.`,
  // image: "faceless_avatar"
  // },
  // {
  //   author: 'Mary',
  //   as: 'Tenant',
  //   text: `Modern, well equipped apartment. A very comfortable stay in an excellent location. Would recommend to others.`,
  // image: "faceless_avatar"
  // },
  // {
  //   author: 'Alex',
  //   as: 'Tenant',
  //   text: `I had a great experience. I was staying in a great place in a nice area and all was well. Hospitality was on point and communication was really good. Everything resulted in a smooth experience for me.`,
  // image: "faceless_avatar"
  // },
  // {
  //   author: 'Cel',
  //   as: 'Tenant',
  //   text: `Simply Amazing. Very accommodating staffs. Superb service. `,
  // image: "faceless_avatar"
  // },
  // {
  //   author: 'Jonathan Guerrer',
  //   as: 'Tenant',
  //   text: `Professional replies, quick turnaround, been in one of their flats for nearly a month now in St Albans Hertfordshire, will recommend their services`,
  // image: "faceless_avatar"
  // },
];
